/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Type_Council_ApprovalInputs */

const en_doc_type_council_approval = /** @type {(inputs: Doc_Type_Council_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Council Approval`)
};

const id_doc_type_council_approval = /** @type {(inputs: Doc_Type_Council_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Persetujuan Dewan/Pemerintah`)
};

/** @type {(inputs: Doc_Type_Council_ApprovalInputs) => LocalizedString} */
const es_doc_type_council_approval = en_doc_type_council_approval;

/** @type {(inputs: Doc_Type_Council_ApprovalInputs) => LocalizedString} */
const fr_doc_type_council_approval = en_doc_type_council_approval;

/** @type {(inputs: Doc_Type_Council_ApprovalInputs) => LocalizedString} */
const de_doc_type_council_approval = en_doc_type_council_approval;

/** @type {(inputs: Doc_Type_Council_ApprovalInputs) => LocalizedString} */
const ja_doc_type_council_approval = en_doc_type_council_approval;

/** @type {(inputs: Doc_Type_Council_ApprovalInputs) => LocalizedString} */
const zh_doc_type_council_approval = en_doc_type_council_approval;

/** @type {(inputs: Doc_Type_Council_ApprovalInputs) => LocalizedString} */
const ar_doc_type_council_approval = en_doc_type_council_approval;

/** @type {(inputs: Doc_Type_Council_ApprovalInputs) => LocalizedString} */
const it_doc_type_council_approval = en_doc_type_council_approval;

/** @type {(inputs: Doc_Type_Council_ApprovalInputs) => LocalizedString} */
const ru_doc_type_council_approval = en_doc_type_council_approval;

/** @type {(inputs: Doc_Type_Council_ApprovalInputs) => LocalizedString} */
const pt_doc_type_council_approval = en_doc_type_council_approval;

/** @type {(inputs: Doc_Type_Council_ApprovalInputs) => LocalizedString} */
const ko_doc_type_council_approval = en_doc_type_council_approval;

/**
* | output |
* | --- |
* | "Council Approval" |
*
* @param {Doc_Type_Council_ApprovalInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const doc_type_council_approval = /** @type {((inputs?: Doc_Type_Council_ApprovalInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Type_Council_ApprovalInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_type_council_approval(inputs)
	if (locale === "es") return es_doc_type_council_approval(inputs)
	if (locale === "fr") return fr_doc_type_council_approval(inputs)
	if (locale === "de") return de_doc_type_council_approval(inputs)
	if (locale === "ja") return ja_doc_type_council_approval(inputs)
	if (locale === "zh") return zh_doc_type_council_approval(inputs)
	if (locale === "ar") return ar_doc_type_council_approval(inputs)
	if (locale === "id") return id_doc_type_council_approval(inputs)
	if (locale === "it") return it_doc_type_council_approval(inputs)
	if (locale === "ru") return ru_doc_type_council_approval(inputs)
	if (locale === "pt") return pt_doc_type_council_approval(inputs)
	return ko_doc_type_council_approval(inputs)
});